import moment from "moment";
import React, { useState } from "react";
import Drawer from "react-bottom-drawer";
import DatePicker from "react-datepicker";
import EdButton from "../edbutton/edButton";
import { previousDay, getFinancialYear, pnlDownloadDate, selectQuarterDateRange, getLastMonthDateRange, getThisMonthDateRange, EDurationType, getPreviousIndianFinancialYear, isFirstDayOfFinancialYear, } from "@domains/utils/reportDates";
const CalendarPopupMob = (props) => {
    var _a;
    const [yearlyDrawer, setYearlyDrawer] = React.useState(false);
    const [customDrawer, setCustomDrawer] = React.useState(false);
    const [endDate, setEndDate] = React.useState(props.endDate);
    const [startDate, setStartDate] = React.useState(props.startDate);
    const financialYear = (() => {
        if (isFirstDayOfFinancialYear())
            return getPreviousIndianFinancialYear().startDate.year();
        return getFinancialYear(new Date());
    })();
    const [selectedDateRange, setSelectedDateRange] = useState("startDateSelected");
    const years = Array.from(new Array(6), (val, index) => financialYear - index);
    const [selectedYear, setSelectedYear] = React.useState(-1);
    const [yearlySelectedDate, setYearlySelectedDate] = React.useState();
    const handleYearly = () => {
        setYearlyDrawer(true);
        props.setOpenCalendar(false);
    };
    const handleCustom = () => {
        setCustomDrawer(true);
        props.setOpenCalendar(false);
        setStartDate(props.startDate);
        setEndDate(props.endDate);
    };
    const handleBack = () => {
        props.setOpenCalendar(true);
        setYearlyDrawer(false);
        setCustomDrawer(false);
    };
    const setFinYear = (index) => {
        var _a, _b, _c, _d;
        let startDate, endDate, durationType;
        props.setOpenCalendar(false);
        props.setFinYear(financialYear - index);
        (_a = props.setNextFinYear) === null || _a === void 0 ? void 0 : _a.call(props, financialYear - index + 1);
        startDate = new Date(financialYear - index, 3, 1);
        if (index === 0) {
            durationType = EDurationType.CY;
            if (new Date(financialYear, 3, 1) > previousDay)
                endDate = new Date(financialYear + 1, 2, 31);
            else
                endDate = previousDay;
        }
        else {
            durationType = EDurationType.NA;
            endDate = new Date(financialYear - index + 1, 2, 31);
        }
        (_b = props === null || props === void 0 ? void 0 : props.setDurationType) === null || _b === void 0 ? void 0 : _b.call(props, durationType);
        (_c = props === null || props === void 0 ? void 0 : props.setStartDate) === null || _c === void 0 ? void 0 : _c.call(props, startDate);
        (_d = props === null || props === void 0 ? void 0 : props.setEndDate) === null || _d === void 0 ? void 0 : _d.call(props, endDate);
        if (props.resetCustomFields)
            props.resetCustomFields();
        if (props.handlePNLDates)
            props.handlePNLDates(durationType, startDate, endDate);
    };
    const setThisMonth = () => {
        var _a, _b, _c, _d;
        let durationType = EDurationType.CM;
        props.setOpenCalendar(false);
        (_a = props === null || props === void 0 ? void 0 : props.setDurationType) === null || _a === void 0 ? void 0 : _a.call(props, durationType);
        let { startDate, endDate } = getThisMonthDateRange();
        (_b = props === null || props === void 0 ? void 0 : props.setStartDate) === null || _b === void 0 ? void 0 : _b.call(props, startDate);
        (_c = props === null || props === void 0 ? void 0 : props.setEndDate) === null || _c === void 0 ? void 0 : _c.call(props, endDate);
        props.setFinYear(financialYear);
        (_d = props.setNextFinYear) === null || _d === void 0 ? void 0 : _d.call(props, financialYear + 1);
        if (props.resetCustomFields)
            props.resetCustomFields();
        if (props.handlePNLDates)
            props.handlePNLDates(durationType, startDate, endDate);
    };
    const setLastMonth = () => {
        var _a, _b, _c, _d;
        let durationType = EDurationType.LM;
        let { startDate, endDate } = getLastMonthDateRange();
        props.setOpenCalendar(false);
        (_a = props === null || props === void 0 ? void 0 : props.setDurationType) === null || _a === void 0 ? void 0 : _a.call(props, EDurationType.LM);
        (_b = props === null || props === void 0 ? void 0 : props.setStartDate) === null || _b === void 0 ? void 0 : _b.call(props, startDate);
        (_c = props === null || props === void 0 ? void 0 : props.setEndDate) === null || _c === void 0 ? void 0 : _c.call(props, endDate);
        props.setFinYear(financialYear);
        (_d = props.setNextFinYear) === null || _d === void 0 ? void 0 : _d.call(props, financialYear + 1);
        if (props.resetCustomFields)
            props.resetCustomFields();
        if (props.handlePNLDates)
            props.handlePNLDates(durationType, startDate, endDate);
    };
    const setQuarter = (index) => {
        var _a, _b, _c;
        const { startDate, endDate } = selectQuarterDateRange(index);
        let endDates = endDate;
        props.setOpenCalendar(false);
        props.setFinYear(financialYear);
        (_a = props.setNextFinYear) === null || _a === void 0 ? void 0 : _a.call(props, financialYear + 1);
        (_b = props === null || props === void 0 ? void 0 : props.setStartDate) === null || _b === void 0 ? void 0 : _b.call(props, startDate);
        let durationType;
        if (index === 0) {
            endDates = previousDay;
            durationType = EDurationType.CQ;
        }
        else {
            durationType = EDurationType.LQ;
        }
        (_c = props === null || props === void 0 ? void 0 : props.setEndDate) === null || _c === void 0 ? void 0 : _c.call(props, endDates);
        if (props.resetCustomFields)
            props.resetCustomFields();
        if (props.handlePNLDates)
            props.handlePNLDates(durationType, startDate, endDates);
    };
    const dateChange = (dates) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
        setSelectedDateRange(end ? "startDateSelected" : "endDateSelected");
    };
    const handleApply = () => {
        var _a, _b, _c, _d, _e, _f;
        setCustomDrawer(false);
        let durationType = EDurationType.NA;
        (_a = props === null || props === void 0 ? void 0 : props.setStartDate) === null || _a === void 0 ? void 0 : _a.call(props, startDate);
        (_b = props === null || props === void 0 ? void 0 : props.setEndDate) === null || _b === void 0 ? void 0 : _b.call(props, endDate);
        (_c = props === null || props === void 0 ? void 0 : props.setDurationType) === null || _c === void 0 ? void 0 : _c.call(props, EDurationType.NA);
        props.setFinYear(startDate.getFullYear());
        setYearlySelectedDate(false);
        if (startDate.getFullYear() === endDate.getFullYear())
            (_d = props.setNextFinYear) === null || _d === void 0 ? void 0 : _d.call(props, endDate.getFullYear() + 1);
        else
            (_e = props.setNextFinYear) === null || _e === void 0 ? void 0 : _e.call(props, endDate.getFullYear());
        if (endDate < new Date(new Date().getFullYear(), 3, 1)) {
            props.setFinYear(endDate.getFullYear() - 1);
            (_f = props.setNextFinYear) === null || _f === void 0 ? void 0 : _f.call(props, endDate.getFullYear());
        }
        if (props.resetCustomFields)
            props.resetCustomFields();
        if (props.handlePNLDates)
            props.handlePNLDates(durationType, startDate, endDate);
    };
    const disableCalenderApply = () => {
        if (props.disableCalenderApply)
            return props.disableCalenderApply(startDate, endDate);
        return startDate && endDate ? false : true;
    };
    React.useEffect(() => {
        if (props.startDate)
            setStartDate(props.startDate);
        if (props.endDate)
            setEndDate(props.endDate);
    }, [props.startDate, props.endDate]);
    React.useEffect(() => {
        disableCalenderApply();
    }, [startDate, endDate]);
    React.useEffect(() => {
        if (!yearlySelectedDate)
            setSelectedYear(-1);
    }, [yearlyDrawer]);
    return (React.createElement("div", { className: "mb-genericSidebar" },
        React.createElement(Drawer, { isVisible: props.openCalendar, onClose: () => props.setOpenCalendar(false), className: `${props.backdropblur && props.backdropblur} ${props.whiteBackground && props.whiteBackground} drawer__handle-wrapper new-background-blur bg_aqua_white z-index-high`, hideScrollbars: true },
            props.calendarlisthead && props.calendarlisthead,
            React.createElement("div", { className: "drawer_container" },
                React.createElement("div", { className: "calendar_list" },
                    React.createElement("div", { className: "list_container", onClick: setThisMonth },
                        React.createElement("span", null, "This Month")),
                    React.createElement("div", { className: "list_container", onClick: setLastMonth },
                        React.createElement("span", null, "Last Month")),
                    React.createElement("div", { className: "list_container", onClick: () => {
                            setQuarter(0);
                        } },
                        React.createElement("span", null, "This Quarter")),
                    React.createElement("div", { className: "list_container", onClick: () => {
                            setQuarter(1);
                        } },
                        React.createElement("span", null, "Last Quarter")),
                    ((_a = props === null || props === void 0 ? void 0 : props.customFields) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                        props.customFields.map((customField) => {
                            return (React.createElement("div", { className: "list_container", onClick: () => customField.Functionality() },
                                React.createElement("span", null, customField.displayText)));
                        }),
                    React.createElement("div", { className: "list_container", onClick: handleYearly },
                        React.createElement("span", { className: "yearly" },
                            "Yearly",
                            React.createElement("div", { className: "right_arrow" },
                                React.createElement("i", { className: "edel-icon-arrow-right1" })))),
                    props.customTime && (React.createElement("div", { className: "list_container", style: { borderBottom: "none" }, onClick: handleCustom },
                        React.createElement("span", { className: "custom" },
                            props.customTimeText
                                ? props.customTimeText
                                : "Custom Time Range",
                            React.createElement("div", { className: "right_arrow" },
                                React.createElement("i", { className: "edel-icon-arrow-right1" })))))))),
        React.createElement("div", null,
            React.createElement(Drawer, { isVisible: yearlyDrawer, onClose: () => setYearlyDrawer(false), className: `${props.backdropblur && props.backdropblur} ${props.whiteBackground && props.whiteBackground} backgroundcolor_bluedrawer drawer__handle-wrapper z-index-high`, hideScrollbars: true },
                React.createElement("div", { className: "drawer_year_container" },
                    props.yearlydroplisthead ? (props.yearlydroplisthead) : (React.createElement("div", { className: "mob_year_container" },
                        React.createElement("div", { className: "heading displayFlex align-items-center" },
                            React.createElement("div", null,
                                React.createElement("i", { className: "edel-icon-arrow-left1", onClick: handleBack })),
                            React.createElement("div", null,
                                React.createElement("b", null, "Select Financial Year"))))),
                    React.createElement("div", { className: "year_list" },
                        years.map((finYear, index) => {
                            return (React.createElement("div", { className: "financial_year", key: index },
                                React.createElement("span", { onClick: () => {
                                        setSelectedYear(index);
                                    }, className: selectedYear === index ? "color_blue" : "", key: index },
                                    "FY ",
                                    finYear,
                                    "-",
                                    (finYear + 1).toString().substring(2))));
                        }),
                        React.createElement("div", { className: "btn-container" },
                            React.createElement("button", { onClick: () => {
                                    setYearlyDrawer(false);
                                    setFinYear(selectedYear);
                                    setYearlySelectedDate(true);
                                } }, "Confirm")))))),
        React.createElement("div", null,
            React.createElement(Drawer, { isVisible: customDrawer, onClose: () => setCustomDrawer(false), hideScrollbars: true, className: ` ${props.backdropblur && props.backdropblur} ${props.whiteBackground && props.whiteBackground} drawer__handle-wrapper backgroundcolor_bluedrawer z-index-high` },
                React.createElement("div", { className: `pandLcalendar common-datepicker  from_to_container_new ${props.calendarFormatWeekClass && props.calendarFormatWeekClass}` },
                    React.createElement("div", { className: "row mx-0" },
                        React.createElement("div", { className: "col-md-12 col-lg-12 common-download-newtheme pandLcalendar-form" },
                            React.createElement("div", { className: "custom_heading" },
                                React.createElement("span", { className: "heading" },
                                    React.createElement("div", { className: "DMSanN_16_400 txt-midnight-blue pdl-20" }, "Custom Date Range"))),
                            React.createElement("div", { className: "row calendar--row mx-0" },
                                props.TopMostReactNodeInCustomPopUp
                                    ? props === null || props === void 0 ? void 0 : props.TopMostReactNodeInCustomPopUp(startDate, endDate)
                                    : null,
                                React.createElement("div", { className: "col px-0" },
                                    React.createElement("div", { className: `DMSanM_14_500 ${selectedDateRange === "startDateSelected"
                                            ? "txt-midight-blue"
                                            : "txt-secondary-gray"}` }, props.fromDateText ? props.fromDateText : "From Date"),
                                    React.createElement("div", { className: "inputFieldCalendarIcon input-group yearDropdown singleDatePicker holdingReportsDate" },
                                        React.createElement("input", { type: "text", className: `form-control date-drawer-input-field  ${selectedDateRange === "startDateSelected"
                                                ? "txt-midight-blue"
                                                : "txt-secondary-gray"}`, placeholder: "dd-mm-YY", value: moment(startDate).format("D-MMM-YY"), readOnly: true }),
                                        !props.isCalendarIconHide ? (React.createElement("a", { className: "input-group-append" },
                                            React.createElement("span", { className: "input-group-text d-block" },
                                                React.createElement("i", { className: "edel-icon-calendar-report" })))) : (""))),
                                React.createElement("div", { className: "col px-0" },
                                    React.createElement("div", { className: `DMSanM_14_500 col pdl-0 ${selectedDateRange === "endDateSelected"
                                            ? "txt-midight-blue"
                                            : "txt-secondary-gray"}

                     ` }, props.toDateText ? props.toDateText : "To Date"),
                                    React.createElement("div", { className: "inputFieldCalendarIcon input-group yearDropdown singleDatePicker holdingReportsDate" },
                                        React.createElement("input", { type: "text", className: `form-control date-drawer-input-field ${selectedDateRange === "endDateSelected"
                                                ? "txt-midight-blue"
                                                : "txt-secondary-gray"}`, placeholder: "dd-mm-YY", value: selectedDateRange === "endDateSelected"
                                                ? "Select End Date"
                                                : moment(endDate).format("D-MMM-YY"), readOnly: true }),
                                        !props.isCalendarIconHide ? (React.createElement("a", { className: "input-group-append" },
                                            React.createElement("span", { className: "input-group-text d-block" },
                                                React.createElement("i", { className: "edel-icon-calendar-report" })))) : ("")))),
                            React.createElement("div", { className: "yearDropdown singleDatePicker holdingReportsDate rangeDatePickerContainer setting-padding arrows-in-yeardrop calendardates-spacing" },
                                " ",
                                React.createElement(DatePicker, { dateFormat: "d-MMM-yy", onChange: dateChange, startDate: startDate, endDate: endDate, selectsRange: true, inline: true, selected: startDate, minDate: props.minDate ? props.minDate : pnlDownloadDate, maxDate: previousDay, formatWeekDay: (nameOfDay) => nameOfDay.slice(0, props.formatWeekCount ? props.formatWeekCount : 1), showYearDropdown: true, showMonthDropdown: true, useShortMonthInDropdown: true, yearDropdownItemNumber: props.minDate
                                        ? previousDay.getFullYear() -
                                            props.minDate.getFullYear() +
                                            1
                                        : previousDay.getFullYear() -
                                            pnlDownloadDate.getFullYear() +
                                            1 })))),
                    React.createElement("div", { className: "custom_buttons" },
                        React.createElement("button", { onClick: () => setCustomDrawer(false), className: "midnight-blue-border ed_button" }, "Cancel"),
                        React.createElement(EdButton, { className: "active", onClick: handleApply, disabled: disableCalenderApply(), value: " Apply", btnTyp: "blue-one" }))))),
        React.createElement("div", null)));
};
export default CalendarPopupMob;
